import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-file-display',
  templateUrl: './file-display.component.html',
  styleUrls: ['./file-display.component.scss']
})
export class FileDisplayComponent {
 constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<FileDisplayComponent>) { }

  closePreview() {
    this.dialogRef.close();
  }
}
